<div class="tabs-container">
  <div *ngFor="let tab of tabs" class="tab" (click)="tabSelectHandler(tab)"
    [ngClass]="{'active': activeId == tab.id || tab.isActive}">
    {{tab.label}}
  </div>
</div>
